import { BaseResAPI } from "@/@core/entity/res-api.entity";
import api from "@/api/axios";

export interface CreateNotificationDTO {
  type: number;
  is_scheduled: boolean;
  title: string;
  description: string;
  link: string;
  media_id: number;
  data_id: number;
  scheduled_at: any;
}

export type CreateNotificationResp = BaseResAPI<null>;

const createNotificationInteractor = (
  params: CreateNotificationDTO
): Promise<CreateNotificationResp> => {
  const path = "/admin/notification";
  return api.post(path, params);
};

export default createNotificationInteractor;
